import { ShBatchTaskTypes } from '@stylehaven/components';

export enum DavBatchTaskType {
    BATCH_SUBMIT_DOSSIERS_TASK = 'SubmitDossiersBatchTask',
    BATCH_DEPOT_DESTRUCTION_CSV = 'DepotDestructionCsvBatchTask',
    BATCH_DEPOT_DESTRUCTION = 'DepotDestructionBatchTask',
    BATCH_CSV_TASK = ShBatchTaskTypes.CSV_TASK
}
